const _GlobalsBaseController = class {
  constructor() {
    this._id = _GlobalsBaseController.__next_id++;
  }
  id() {
    return this._id;
  }
  handle_globals_node(globals_node, output_name, shaders_collection_controller) {
  }
  handleGlobalVar(globals_node, output_name, glType, shaders_collection_controller) {
  }
};
export let GlobalsBaseController = _GlobalsBaseController;
GlobalsBaseController.__next_id = 0;
